
import { Testimonial } from "@/components/index/testimonials/types";
import { mockTestimonials } from "@/data/mockTestimonials";
import { ServiceResponse } from "./types";

// Simulate API delay
const simulateDelay = (ms: number = 300) => new Promise(resolve => setTimeout(resolve, ms));

/**
 * Get all testimonials
 */
export const getAllTestimonials = async (): Promise<ServiceResponse<Testimonial[]>> => {
  try {
    await simulateDelay();
    return { data: mockTestimonials };
  } catch (error) {
    console.error("Error fetching testimonials:", error);
    return { data: [], error: "Failed to fetch testimonials" };
  }
};

/**
 * Get featured testimonials (top rated ones)
 */
export const getFeaturedTestimonials = async (limit: number = 3): Promise<ServiceResponse<Testimonial[]>> => {
  try {
    await simulateDelay();
    // Get top rated testimonials
    const featured = [...mockTestimonials]
      .sort((a, b) => b.rating - a.rating)
      .slice(0, limit);
    return { data: featured };
  } catch (error) {
    console.error("Error fetching featured testimonials:", error);
    return { data: [], error: "Failed to fetch featured testimonials" };
  }
};

/**
 * Get testimonial by id
 */
export const getTestimonialById = async (id: string): Promise<ServiceResponse<Testimonial | null>> => {
  try {
    await simulateDelay();
    const testimonial = mockTestimonials.find(t => t.id === id);
    if (!testimonial) {
      return { data: null, error: "Testimonial not found" };
    }
    return { data: testimonial };
  } catch (error) {
    console.error(`Error fetching testimonial with id ${id}:`, error);
    return { data: null, error: "Failed to fetch testimonial" };
  }
};
